import { render, staticRenderFns } from "./TepNominacionExport.vue?vue&type=template&id=eb4e0434"
import script from "./TepNominacionExport.vue?vue&type=script&lang=js"
export * from "./TepNominacionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports